export const LEAD_TABLE_COLUMN_DEFAULTS = {
  reference: true,
  name: true,
  email: true,
  phone: true,
  company: true,
  city: true,
  address: true,
  source: true,
  status: true,
  assigned_to: true,
  value: true,
  created_at: true,
  updated_at: true,
  action: true
}

export const LEAD_TABLE_COLUMN_LABELS = {
  reference: 'reference',
  name: 'name',
  email: 'email',
  phone: 'phone',
  company: 'company',
  city: 'city',
  address: 'address',
  source: 'source',
  status: 'status',
  assigned_to: 'assigned_to',
  value: 'value',
  created_at: 'created_at',
  updated_at: 'updated_at',
  action: 'action'
}

export function getLeadTableColumnDefaults() {
  return { ...LEAD_TABLE_COLUMN_DEFAULTS }
}
